<template>
    <div v-if="issue_obj">
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                    label="* Issue ID"
                    readonly
                    class="w-full"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model="issue_obj.reported_by"
                    label="* Reported By"
                    placeholder="Auto Filled"
                    :multiple="false"
                    :load_initial="false"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="true"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="true"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.reported_by">
                    {{ api_errors.reported_by.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.hazard_type"
                    label="Type"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_hazard_type}`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.hazard_type">
                    {{ api_errors.data.hazard_type.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block">Close out Assigned To</label>
                <vs-input
                    v-model="issue_obj.data.close_out_assigned_to"
                    class="w-full"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.close_out_assigned_to">
                    {{ api_errors.data.close_out_assigned_to.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.category"
                    label="Category"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_categories}?issue_type_category=hazard&active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    @change="!issue.id ? issue_obj.data.issue_type = null : null"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.category">
                    {{ api_errors.data.category.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.issue_type"
                    label="Issue Type"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="issue_obj.data.category ? true : false"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_issues_types}?category=${issue_obj.data.category ? issue_obj.data.category.id : null}&active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="!issue_obj.data.category || mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.issue_type">
                    {{ api_errors.data.issue_type.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.target_close_out_date" :allow_future_dates="true" :minimum_date="prev_date" label="Target Close out Date" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.target_close_out_date">
                    {{ api_errors.data.target_close_out_date.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <InputSelect 
                    :model.sync="issue_obj.data.potential" 
                    input_class="w-full bg-white" 
                    label="Potential"
                    :options="potential_options"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.potential">
                    {{ api_errors.data.potential.join(', ') }}
                </small>
                
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.assigned_reviewers"
                    label="Select Incident Manager"
                    placeholder="Type to Search..."
                    :multiple="true"
                    :load_initial="true"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :close_on_select="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                    {{ api_errors.assigned_reviewers.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.date" label="Date" />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4">
                <label class="vs-input--label block mb-1">Description</label>
                <vs-textarea v-model="issue_obj.data.description" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.description">
                    {{ api_errors.data.description.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="4">
                <label class="vs-input--label block mb-1">Remarks</label>
                <vs-textarea v-model="issue_obj.data.remarks" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                    {{ api_errors.data.remarks.join(', ') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <FileSelection
                        :images.sync="issue_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                <LocationChooser :disabled="mode != 'e'" :latitude.sync="issue_obj.data.location_latitude" :longitude.sync="issue_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" />
            </vs-col>
        </vs-row>

        <vs-row class="mt-base" v-if="show_action_buttons && show_review && $store.state.is_online">
            <vs-col class="text-center">
                <vs-button @click="$emit('reject')" type="filled" color="primary" class="mx-2">
                    Reject
                </vs-button>
                <vs-button @click="$emit('approve')" type="filled" color="primary" class="mx-2">
                    Approve
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import SelectDate  from '../../../components/letstream/ls-select-date/SelectDate.vue'
import FileSelection from "../Components/FileSelection.vue"
import LocationChooser from '../Components/LocationChooser.vue'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        show_action_buttons: {
            required: true,
            type: Boolean
        },
        show_review: {
            required: true,
            type: Boolean
        },
        manager_dropdown: {
            required: true,
            type: Function
        }
    },
    components: {
        FileSelection,
        LocationChooser,
        SelectDate
    },
    data () {

        const today = new Date(Date.now())
        let prevDate = today;
        prevDate.setDate(today.getDate() - 1)

        return {
            issue_obj: null,
            default_data: {
                category: null,
                issue_type: null,
                date: new Date(Date.now()),
                close_out_assigned_to: null,
                target_close_out_date: null,
                potential: null,
                location_latitude: null,
                location_longitude: null,
                hazard_type: null,
                remarks: null,
                description: null
            },
            potential_options: [
                {label: 'High', value: 'h'},
                {label: 'Medium', value: 'm'},
                {label: 'Low', value: 'l'}
            ],

            prev_date: prevDate
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        }
    }
}
</script>
